import * as actionTypes from "../action-types";

const initialState = {
    superadminAdminPartnerDetails: {},
};

const authReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_SUPERADMIN_ADMIN_PARTNER_DETAILS:
            return { ...state, superadminAdminPartnerDetails: payload };

        default:
            return state;
    }
};

export default authReducer;